<template>
  <transition name="modal-fade">
    <div class="modal-backdrop" style="padding: 1em;">
      <div class="modal"
        role="dialog"
        aria-labelledby="modalTitle"
        aria-describedby="modalDescription">
        <header class="modal-header" id="modalTitle">
            <el-row>
              {{mode==1?'新增':'修改'}}推薦人資料&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <el-button icon="el-icon-check" @click="submitForm('form')">{{$t('message.Keep_txt')}}</el-button>&nbsp;&nbsp;&nbsp;
              <el-button icon="el-icon-check" type="success" @click="sendForm('form')" v-if="(form.status<2) && (mode<3)">儲存並寄送推薦通知信</el-button>&nbsp;&nbsp;&nbsp;
              <el-button icon="el-icon-close" @click="$emit('close')">{{$t('message.Close_cmd')}}</el-button>
            </el-row>
        </header>
        <section class="modal-body" id="modalDescription">
            <el-form ref="form" :model="form" :rules="rules" label-width="135px">
              <!--<el-form-item style="margin-bottom: 1em;">
                </el-form-item> -->
                <el-form-item label="姓名" prop="name" style="margin-bottom: 1.25em;">
                    <el-input v-model="form.name" placeholder="推薦師長姓名" ></el-input>
                </el-form-item> 
                <el-form-item label="任職單位" prop="unit" style="margin-bottom: 1.25em;">
                    <el-input v-model="form.unit" placeholder="推薦人任職單位" :maxlength="20"></el-input>
                </el-form-item> 
                <el-form-item label="職稱" prop="title" style="margin-bottom: 1.25em;">
                    <el-input v-model="form.title" placeholder="推薦人職稱" :maxlength="20"></el-input>
                </el-form-item> 
                <el-form-item label="與申請人關係" prop="relation" style="margin-bottom: 1.25em;">
                    <el-input v-model="form.relation" :maxlength="20"></el-input>
                </el-form-item> 
                <el-form-item label="推薦師長 Email (勿填考生本人電郵)" prop="email" style="margin-bottom: 1.25em;">
                    <el-input v-model="form.email" :maxlength="30"></el-input>
                </el-form-item> 
                <el-form-item label="連絡電話" prop="phoneNo" style="margin-bottom: 1.25em;" v-show="false">
                    <el-input v-model="form.phoneNo"></el-input>
                </el-form-item> 
                <h5 style="text-align: left;color:red;">
                  重要提醒：請考生務必與推薦師長連繫，請師長記得至Email收取信件並將推薦資料於規定時間內送出。否則，視同未繳件。
                </h5>
            </el-form>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'editData',
  props: [
    'recId', 'mode'
  ],
  data () {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('姓名不能空白'));
      } else {
        callback();
      }
    };
    var checkUnit = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('任職單位不能空白'));
      } else {
        callback();
      }
    };
    var checkTitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('職稱不能空白'));
      } else {
        callback();
      }
    };
    var checkRelation = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('與申請人關係不能空白'));
      } else {
        callback();
      }
    };
    var checkEMail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Email不能空白'));
      } else {
        callback();
      }
    };
    return {
      form: {
        documentID: 0,
        recID: 0,
        name: '',
        unit: '',
        title: '',
        relation: '',
        email: '',
        phoneNo: '',
        status: 255,
        hId:''        
      },
      rules:{
       name:[{required: true, validator: checkName,trigger:"blur"}],
       unit:[{required: true, validator: checkUnit,trigger:"blur"}],
       title:[{required: true, validator: checkTitle,trigger:"blur"}],
       relation:[{required: true, validator: checkRelation,trigger:"blur"}],
       email:[{required: true, validator: checkEMail,trigger:"blur"}],
      }
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  methods: {
    submitForm(form) {
      this.$refs.form.validate((valid) => {        
        console.log('======submitForm ===== valid:'+valid)
        if (valid) {
          var vm = this;
          this.form.updateUser = this.user.id;      
          this.form.documentID = this.user.dId;
          this.$http.put('./WebApi/Apply/SetRecommendInfo',this.form)
                    .then((response) =>{ 
                        const h = vm.$createElement;       
                        if (true == response.data) {
                            vm.$notify({
                                      title: vm.$t('message.Success_txt'),
                                      dangerouslyUseHTMLString: true,
                                      message: '<strong>恭喜您,存檔成功</strong>',
                                      type: 'success',
                                      offset: 150
                                    });
                            vm.$emit('close')
                        } else {
                            vm.$notify.error({
                                            title: vm.$t('message.Error_txt'),
                                            dangerouslyUseHTMLString: true,
                                            message: '<strong>對不起,寄件失敗</strong>',
                                            offset: 150
                                          });
                        }
                    })
                    .catch(function (error) {
                      vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                        offset: 150
                                      });
                    })
        } else {
          this.$notify.error({
                              title: this.$t('message.Error_txt'),
                              dangerouslyUseHTMLString: true,
                              message: '<strong>對不起,驗證失敗</strong>',
                              offset: 150
                            });
          return false;
        }
      });
    },
    sendForm(form) {
      this.$refs.form.validate((valid) => {        
        console.log('======submitForm ===== valid:'+valid)
        if (valid) {
          var vm = this;
          this.form.updateUser = this.user.id;      
          this.form.documentID = this.user.dId;          
          this.form.status     = this.sysId;
          this.$http.put('./WebApi/Apply/SendRecommendInfo',this.form)
                    .then((response) =>{ 
                        const h = vm.$createElement;       
                        if (true == response.data) {
                            vm.$notify({
                                      title: vm.$t('message.Success_txt'),
                                      dangerouslyUseHTMLString: true,
                                      message: '<strong>恭喜您,存檔成功</strong>',
                                      type: 'success',
                                      offset: 150
                                    });
                            vm.$emit('close')
                        } else {
                            vm.$notify.error({
                                            title: vm.$t('message.Error_txt'),
                                            dangerouslyUseHTMLString: true,
                                            message: '<strong>對不起,寄件失敗</strong>',
                                            offset: 150
                                          });
                        }
                    })
                    .catch(function (error) {
                      vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                                        offset: 150
                                      });
                    })
        } else {
          this.$notify.error({
                              title: this.$t('message.Error_txt'),
                              dangerouslyUseHTMLString: true,
                              message: '<strong>對不起,驗證失敗</strong>',
                              offset: 150
                            });
          return false;
        }
      });
    },
    getRecommendData: function () {
      return this.$http
        .get('./WebApi/Apply/GetRecommendInfo/'.concat(this.recId));
    },
  },
  created () {
    console.log('======created EditData =====')
    let vm = this
    this.$http.all([this.getRecommendData()])
        .then(vm.$http.spread(function (data1) {
            if (data1.data != null) {
                vm.form.recID    = data1.data.recID;
                vm.form.hId      = data1.data.hId;
                vm.documentID    = data1.data.documentID;
                vm.form.name     = data1.data.name;
                vm.form.title    = data1.data.title;
                vm.form.unit     = data1.data.unit;
                vm.form.relation = data1.data.relation;
                vm.form.email    = data1.data.eMail;
                vm.form.phoneNo  = data1.data.phoneNo;
                vm.form.status   = data1.data.status;
            }
      }))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pull-right {
  float: right;
}
.well {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
  box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
}
.modal-backdrop 
{ 
    position: fixed;
    top: 0; 
    right: 0; 
    bottom: 0; 
    left: 0; 
    background-color: rgba(0,0,0,.3); 
    display: flex; 
    justify-content: center; 
    align-items: center; 
} 
.modal { 
    background-color: #fff;  
    transform: translate(0,0); 
    z-index: 1050; 
    width: 900px;
    display: block; 
    flex-direction: column; 
    position: relative;  
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border: 1px solid #999;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 6px;
    outline: 0;
    -webkit-box-shadow: 0 3px 9px rgba(0,0,0,.5);
    box-shadow: 0 3px 9px rgba(0,0,0,.5);
} 
.modal-header, .modal-footer { 
    padding: 15px; 
    display: flex; 
} 
.modal-header { 
    border-bottom: 1px solid #eee; 
    color: #4aae9b; 
    justify-content: space-between; 
} 
.modal-footer { 
    border-top: 1px solid #eee; 
    justify-content: flex-end; 
} 
.modal-body { 
    position: relative; 
    padding: 20px 10px; } 
    .btn-close { 
    border: none 0; 
    font-size: 20px; 
    padding: 20px; 
    cursor: pointer; 
    font-weight: 
    bold; color: #4aae9b; 
    background-color: transparent; 
}
</style>


// WEBPACK FOOTER //
// src/components/EditData.vue